import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgNoteMentionEntityIcon = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		d: "M22 10V18C22 20.2091 20.2091 22 18 22H6C3.79086 22 2 20.2091 2 18V10M22 10C22 7.79086 20.2091 6 18 6H6C3.79086 6 2 7.79086 2 10M22 10C22 10 18.8878 12.7147 12 12.6093M2 10C2 10 5.11216 12.5039 12 12.6093M8 6V5C8 3.34315 9.34315 2 11 2H13C14.6569 2 16 3.34315 16 5V6M12 12.6093V11.1093M12 12.6093V14.1093",
		stroke: "currentColor",
		strokeWidth: 2,
		strokeLinecap: "round"
	})]
});
const ForwardRef = forwardRef(SvgNoteMentionEntityIcon);
export default ForwardRef;
